// pages/InvitationPreviewFrame.js
//
// /invitation-preview: the invitation page, fed an unsaved invitation by the
// create form that embeds it.
//
// Why an iframe and not the component dropped into the form: the invitation
// is laid out for a phone's viewport. Its header, background, effect and
// bottom RSVP pill are position: fixed; its cover is sized from the window;
// its mobile styles are media queries. Inside a 390px iframe every one of
// those resolves against a phone-sized window, so the preview is laid out,
// scrolls and animates exactly as the published invitation does on a guest's
// phone. Rendered inline, the same rules would resolve against the desktop
// window and the preview would be a different page.
//
// The row arrives by postMessage (see components/create/InvitationPreview.js)
// and is re-sent on every edit, so the preview follows the form live.
import React, { useEffect, useState } from 'react';
import EventInvitation from './EventInvitation';
import { PREVIEW_READY, PREVIEW_EVENT } from '../utils/previewEvent';

export default function InvitationPreviewFrame() {
  const [row, setRow] = useState(null);

  useEffect(() => {
    const onMessage = (e) => {
      // Same origin, and only from the page that embeds this one.
      if (e.origin !== window.location.origin || e.source !== window.parent) return;
      if (e.data?.type === PREVIEW_EVENT && e.data.row) setRow(e.data.row);
    };
    window.addEventListener('message', onMessage);
    // Asks for the current invitation: the form may have posted before this
    // page had loaded enough to listen.
    if (window.parent !== window) {
      window.parent.postMessage({ type: PREVIEW_READY }, window.location.origin);
    }
    return () => window.removeEventListener('message', onMessage);
  }, []);

  if (!row) {
    return (
      <div className="ed ed--center">
        <p className="ed-error-text">
          {window.parent === window ? 'Open the preview from the invitation editor.' : 'Loading preview…'}
        </p>
      </div>
    );
  }

  return <EventInvitation previewEvent={row} />;
}
